import React from "react";
import { useLang } from "../i18n/LanguageContext";

export const LanguageSwitcher = () => {
  const { lang, setLang, languages } = useLang();

  return (
    <div
      className="inline-flex items-center gap-1 bg-white/10 backdrop-blur rounded-full p-1"
      data-testid="language-switcher"
    >
      {languages.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-bold transition ${
              active
                ? "bg-orange-500 text-white shadow"
                : "text-white/80 hover:bg-white/10"
            }`}
            aria-pressed={active}
          >
            <img
              src={l.flag}
              alt={l.label}
              width="16"
              height="12"
              className="rounded-sm"
              style={{ objectFit: "cover" }}
            />
            {l.label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
